import { Clock, TrendingUp, FileText } from "lucide-react";
import { Card } from "../../../../../../shared/card/card.tsx";
import styles from "./overview-summary-cards.module.css";

interface OverviewSummaryCardsProps {
  totalTime: string;
  targetHours: number;
  projectCount: number;
  utilization: number;
}

export const OverviewSummaryCards = ({
  totalTime,
  targetHours,
  projectCount,
  utilization,
}: OverviewSummaryCardsProps) => {
  // Helper to format HH:MM string to "clean" numeric string
  const formatTimeString = (timeStr: string | undefined | null) => {
    if (!timeStr) return "0";
    const [h, m] = timeStr.split(":").map(Number);
    const total = h + m / 60;
    return Number(total.toFixed(1)).toString();
  };

  // Helper to format numbers without trailing .0
  const formatValue = (val: number | undefined | null) =>
    val !== undefined && val !== null ? Number(val.toFixed(1)).toString() : "0";

  return (
    <div className={styles.gridContainer}>
      <Card padding="5xl" className={styles.card}>
        <div className={styles.header}>
          <span className="sub-heading-sm uppercase">TOTAL HOURS</span>
          <div className={styles.iconContainer}>
            <Clock size={18} className={styles.icon} />
          </div>
        </div>
        <div className="heading-xl font-700">{formatTimeString(totalTime)}</div>
        <div className="sub-heading-xs">Target: {targetHours} hrs</div>
      </Card>

      <Card padding="5xl" className={styles.card}>
        <div className={styles.header}>
          <span className="sub-heading-sm uppercase">PROJECTS</span>
          <div className={styles.iconContainer}>
            <FileText size={18} className={styles.icon} />
          </div>
        </div>
        <div className="heading-xl font-700">{projectCount}</div>
        <div className="sub-heading-xs">Active Projects</div>
      </Card>

      <Card padding="5xl" className={styles.card}>
        <div className={styles.header}>
          <span className="sub-heading-sm uppercase">UTILIZATION</span>
          <div className={styles.iconContainer}>
            <TrendingUp size={18} className={styles.icon} />
          </div>
        </div>
        <div className="heading-xl font-700">{formatValue(utilization)}%</div>
        <div className="sub-heading-xs">Avg. across projects</div>
      </Card>
    </div>
  );
};
